module.exports = __webpack_public_path__ + "static/media/loader.db0aed51.svg";